import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface PhoneInputProps extends Omit<TextFieldProps, 'onChange'> {
    value: string;
    onChange: (value: string) => void;
    label?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
    value,
    onChange,
    label = 'Telefone',
    ...props
}) => {
    // Função que formata o número conforme digita
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let digits = e.target.value.replace(/\D/g, '').slice(0, 11); // só números, max 11 dígitos

        // Se tiver até 10 dígitos, máscara de fixo; se tiver 11, máscara de celular
        let formatted;
        if (digits.length <= 10) {
            // (99) 9999-9999
            formatted = digits.replace(
                /^(\d{0,2})(\d{0,4})(\d{0,4}).*$/,
                (_m, ddd, part1, part2) =>
                    (ddd ? `(${ddd}` : '') +
                    (ddd?.length === 2 ? ') ' : '') +
                    part1 +
                    (part2 ? `-${part2}` : '')
            );
        } else {
            // (99) 99999-9999
            formatted = digits.replace(
                /^(\d{0,2})(\d{0,5})(\d{0,4}).*$/,
                (_m, ddd, part1, part2) =>
                    (ddd ? `(${ddd}` : '') +
                    (ddd?.length === 2 ? ') ' : '') +
                    part1 +
                    (part2 ? `-${part2}` : '')
            );
        }

        onChange(formatted);
    };

    return (
        <TextField
            {...props}
            label={label}
            value={value}
            onChange={handleChange}
            inputProps={{ maxLength: 15 }} // para evitar colar strings muito longas

        />
    );
};

export default PhoneInput;
